/**
 * The iteration interval at which the next progress call should be performed.
 */
export const BYTES_INTERVAL = 200000;
//# sourceMappingURL=common.js.map